import '@/shared/App.css'
import '@/shared/styles/permission-error.css'
import { Toaster } from "@/shared/components/ui/toaster"
import { Toaster as Sonner } from "sonner"
import PermissionErrorHandler, { showPermissionError, isPermissionError } from "@/shared/components/PermissionErrorHandler"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useEffect } from 'react'
import { initErrorSuppressor } from '@/shared/utils/errorSuppressor'

// Create a client with global error handling
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry on permission errors
        if (isPermissionError(error)) {
          return false;
        }
        return failureCount < 1;
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      onError: (error) => {
        // Handle permission errors globally for queries
        if (isPermissionError(error)) {
          showPermissionError(error);
        }
      },
    },
    mutations: {
      onError: (error) => {
        // Handle permission errors globally for mutations
        if (isPermissionError(error)) {
          showPermissionError(error);
        } else if (error.message?.includes('Session expired')) {
          toast.error('Session Expired', {
            description: 'Please login again to continue.',
            duration: 4000,
          });
        } else if (error.message?.includes('Foreign key constraint') || 
                   error.message?.includes('constraint violated')) {
          toast.error('Update Failed', {
            description: 'Unable to complete this action. Please try again or contact support.',
            duration: 5000,
          });
        }
      },
    },
  },
})

export default function AppShell({ children }) {
  // Initialize error suppressor to prevent browser alerts
  useEffect(() => {
    initErrorSuppressor();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <PermissionErrorHandler />
      {children}
      <Toaster />
      <Sonner 
        position="top-center"
        expand={true}
        richColors
        closeButton
        theme="light"
        toastOptions={{
          duration: 5000,
          className: 'custom-toast',
        }}
      />
    </QueryClientProvider>
  )
}

